module.exports = __webpack_public_path__ + "img/banner_left.d23e9703.png";